import React from "react";

import classNames from "classnames";

import {ReviewChoice} from "@globals/DailyOrders/interfaces";

import styles from "./DishReviewChoices.scss";

export default function DishReviewChoices({
  showComment,
  setShowCommentForm,
  selectedChoices,
  setSelectedChoices,
  availableChoices,
}: {
  showComment: boolean;
  setShowCommentForm: (showComment: boolean) => void;
  selectedChoices: number[];
  setSelectedChoices: (selectedChoices: number[]) => void;
  availableChoices: ReviewChoice[];
}): JSX.Element {
  const isActive = (choiceId: number) => {
    return selectedChoices.includes(choiceId);
  };

  const toggleChoice = (choiceId: number) => {
    if (isActive(choiceId)) {
      setSelectedChoices(selectedChoices.filter((id) => id !== choiceId));
    } else {
      setSelectedChoices([...selectedChoices, choiceId]);
    }
  };

  return (
    <ul className={styles.choicesList}>
      {availableChoices?.map((choice) => (
        <li key={choice.id}>
          <button
            type="button"
            onClick={() => toggleChoice(choice.id)}
            className={classNames(
              styles.choiceButton,
              isActive(choice.id) && styles.selected
            )}
          >
            {choice.choice}
          </button>
        </li>
      ))}
      <li>
        <button
          type="button"
          onClick={() => setShowCommentForm(!showComment)}
          className={classNames(
            styles.choiceButton,
            showComment && styles.selected
          )}
        >
          Other
        </button>
      </li>
    </ul>
  );
}
